import { Component, forwardRef, Input } from '@angular/core';

@Component({
  selector: 'hub-button-icon-only',
  templateUrl: './hub-button-icon-only.component.html',
  styleUrls: ['./hub-button-icon-only.component.scss'],
  providers: [],
})
export class HubButtonIconOnlyComponent {
  @Input() icon: string = '';
  @Input() iconColor?: string = '#6D6D6D';
  @Input() background: string = '';

  @Input() showNotification? : boolean = false;

  @Input() left: string = '0px'; // Default to no margin
  @Input() right: string = '0px'; // Default to no margin
  @Input() top: string = '0px'; // Default to no margin
  @Input() bottom: string = '0px'; // Default to no margin
}
